import React, { useState } from 'react';

import { Table } from '@unimed-fesp/components';

import FadeIn from '../../atoms/FadeIn';

import TableHistoricoBody from './TableHistoricoBody';
import TableHistoricoHeader from './TableHistoricoHeader';

const TableHistoricoAlteracoesLista = ({ historicoAlteracoes }) => {
  const paginationInicialParams = {
    pageNumber: 1,
    pageSize: 5,
  };

  const [paginationParams, setPaginationParams] = useState(
    paginationInicialParams
  );
  return (
    <FadeIn>
      <Table head={<TableHistoricoHeader />}>
        <TableHistoricoBody
          paginationParams={paginationParams}
          historicoAlteracoes={historicoAlteracoes}
          setPaginationParams={setPaginationParams}
        />
      </Table>
    </FadeIn>
  );
};

export default TableHistoricoAlteracoesLista;
